/*
 * @Desc: 公共工具方法
 * @Author: jiayi zhu
 * @Date: 2019-11-04 16:39:07
 * @LastEditors: cxt
 */

import history from 'histories';
import pConfig from 'pConfig';
import { store } from 'src/redux/store';

/* eslint-disable */

// 对Date的扩展，将 Date 转化为指定格式的String
// 月(M)、日(d)、小时(h)、分(m)、秒(s)、季度(q) 可以用 1-2 个占位符，
// 年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字)
// 例子：
// (new Date()).Format("yyyy-MM-dd hh:mm:ss.S") ==> 2006-07-02 08:09:04.423
// (new Date()).Format("yyyy-M-d h:m:s.S")      ==> 2006-7-2 8:9:4.18
Date.prototype.format = function (fmt) {
  var o = {
    'M+': this.getMonth() + 1, //月份
    'd+': this.getDate(), //日
    'h+': this.getHours(), //小时
    'm+': this.getMinutes(), //分
    's+': this.getSeconds(), //秒
    'q+': Math.floor((this.getMonth() + 3) / 3), //季度
    S: this.getMilliseconds() //毫秒
    // "W"  : this.weekday()
  };
  if (/(y+)/.test(fmt))
    fmt = fmt.replace(
      RegExp.$1,
      (this.getFullYear() + '').substr(4 - RegExp.$1.length)
    );
  for (var k in o)
    if (new RegExp('(' + k + ')').test(fmt))
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length)
      );
  return fmt;
};

const isMobile = {
  Windows: function () {
    return /IEMobile/i.test(navigator.userAgent);
  },
  Android: function () {
    return /Android/i.test(navigator.userAgent);
  },
  iOS: function () {
    return /iPhone|iPad|iPod/i.test(navigator.userAgent);
  },
  Hw: function () {
    return /HuaweiHealth/.test(navigator.userAgent);
  },
  app: function () {
    let standalone = window.navigator.standalone,
      userAgent = window.navigator.userAgent.toLowerCase(),
      safari = /safari|micromessenger/.test(userAgent),
      ios = /iphone|ipod|ipad/.test(userAgent);

    let result = false;
    if (ios) {
      if (!standalone && !safari) {
        result = true;
      }
    } else {
      if (/boohee/.test(userAgent)) {
        result = true;
      }
    }
    return result;
  },
  weixin: function () {
    let ua = navigator.userAgent.toLowerCase();
    let isWeixin = ua.indexOf('micromessenger') != -1;
    if (isWeixin) {
      return true;
    } else {
      return false;
    }
  },
  Boohee: function () {
    return /boohee/i.test(navigator.userAgent);
  },
  BooheeIOS: function () {
    return this.iOS() && this.Boohee();
  },
  BooheeAndroid: function () {
    return this.Android() && this.Boohee();
  },
  BooheeHealth: function () {
    console.log("当前设备的UA：", navigator.userAgent);
    console.log("是否是健康应用：", this.Boohee());
    console.log("是否不为食物库app", !/food/i.test(navigator.userAgent));
    return this.Boohee() && !/food/i.test(navigator.userAgent);
  },
  BooheeHealthIOS: function () {
    return this.iOS() && this.BooheeHealth();
  },
  BooheeHealthAndroid: function () {
    return this.Android() && this.BooheeHealth();
  },
  Food: function () {
    return this.Boohee() && /food/i.test(navigator.userAgent);
  },
  FoodIOS: function () {
    return this.iOS() && this.Food();
  },
  FoodAndroid: function () {
    return this.Android() && this.Food();
  },
  AliApp: () => {
    return /AliApp/i.test(navigator.userAgent);
  },
  Alipay: () => {
    return /AlipayClient/i.test(navigator.userAgent);
  },
  Taobao: () => {
    return (
      /AliApp/i.test(navigator.userAgent) && /TB/i.test(navigator.userAgent)
    );
  },
  AliHealth: () => {
    return (
      /AliApp/i.test(navigator.userAgent) &&
      /AliHealthClient/i.test(navigator.userAgent)
    );
  },
  WeixinMiniProgram: () => {
    return window.__wxjs_environment === 'miniprogram';
  }
};

/*
  * @description: 显示toast提示
  * @param {String} title 提示信息
  * @param {Boolean} mask 是否使用遮罩
  * @param {Number} duration 显示时长ms
  */
const showToast = (title, duration = 1500, mask = true, callback) => {
  if (!title) return false;
  const toastList = document.getElementsByClassName('liu-toast');
  for (let i = 0; i < toastList.length; i++) {
    toastList[i].remove();
  }
  const toastHtml = document.createElement('div');
  toastHtml.className = 'liu-toast';
  if (mask) {
    toastHtml.style = 'position: fixed; top: 0; left: 0; width: 100vw; height: 100vh; opacity: 0; transition: opacity .2s;';
  }
  const toast = document.createElement('div');
  toast.style = 'position: absolute; left: 50%; bottom: 50%; transform: translateX(-50%); min-height: 32px; line-height: 18px; background-color: rgba(0, 0, 0, 0.6); padding: 7px 10px; color: #fff; font-size: 12px; text-align: center; border-radius: 6px; box-sizing: border-box;';
  const toastText = document.createElement('div');
  toastText.style = 'text-overflow: -o-ellipsis-lastline; overflow: hidden; text-overflow: ellipsis; display: -webkit-box; -webkit-line-clamp: 4; line-clamp: 4; -webkit-box-orient: vertical;';
  const text = document.createTextNode(title);
  toastText.appendChild(text);
  toast.appendChild(toastText);
  toastHtml.appendChild(toast);
  document.body.appendChild(toastHtml);
  setTimeout(() => {
    toastHtml.style.opacity = 1;
  });
  setTimeout(() => {
    toastHtml.style.opacity = 0;
    setTimeout(() => {
      toastHtml.remove();
    }, 200);
    if (callback && typeof callback === 'function') {
      callback();
    }
  }, duration);
}

const toQueryString = (paramsObject) => {
  return Object.keys(paramsObject)
    .map(function (key) {
      return (
        encodeURIComponent(key) + '=' + encodeURIComponent(paramsObject[key])
      );
    })
    .join('&');
}

const serializeQueryString = (obj) => {
  const str = [];
  for (const p in obj) {
    if (obj.hasOwnProperty(p)) {
      str.push(`${encodeURIComponent(p)}=${encodeURIComponent(obj[p])}`);
    }
  }

  return str.join('&');
}

const getQueryString = (name, url) => {
  if (!url) url = window.location.href;
  if (!name) {
    // 如果没有参数，默认获取全部
    try {
      url = url.match(/\?([^#]+)/)[1];
      const obj = {},
        arr = url.split('&');
      for (let i = 0; i < arr.length; i++) {
        const subArr = arr[i].split('=');
        const key = decodeURIComponent(subArr[0]);
        const value = decodeURIComponent(subArr[1]);
        obj[key] = value;
      }
      return obj;
    } catch (err) {
      return null;
    }
  }
  name = name.replace(/[\[\]]/g, '\\$&');
  const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}


const guid = () => {
  const s4 = () => {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  };

  return (
    s4() +
    s4() +
    '-' +
    s4() +
    '-' +
    s4() +
    '-' +
    s4() +
    '-' +
    s4() +
    s4() +
    s4()
  );
}

const isMiniProgram = () => {
  const appDevice = getQueryString('app_device');
  return appDevice === 'mini_program';
}

const headers = (token, others = {}) => {
  return Object.assign({ token: token, AppDevice: 'web' }, others);
}

const saveById = (records) => {
  let result = { byId: {} };
  let ids = records.map(record => {
    result.byId[record.id] = record;
    return record.id;
  });

  result.ids = ids;
  return result;
}

const downloadFile = (filePath) => {
  var link = document.createElement('a');
  link.href = filePath;
  link.download = filePath.substr(filePath.lastIndexOf('/') + 1);
  link.click();
}
/**
 * 比较日期时间差
 * @method getDateDiff
 * @param {String} startDate 开始日期.
 * @param {String} endDate 参考版本.
 * @return {number} 返回日期时间差.
 */
const getDateDiff = (startDate, endDate) => {
  var startTime = new Date(
    Date.parse(startDate.replace(/-/g, '/'))
  ).getTime();
  var endTime = new Date(Date.parse(endDate.replace(/-/g, '/'))).getTime();
  var dates = (endTime - startTime) / (1000 * 60 * 60 * 24);
  return dates;
}

/**
 * 秒转换成是h:m:s
 * @method farmatTime
 * @param {String} 格式化前的时间.
 * @return {number} 返回格式化后的时间.
 */
const formatTime = (seconds) => {
  var time = parseInt(seconds);
  if (time < 3600) {
    return [parseInt((seconds / 60) % 60), parseInt(seconds % 60)]
      .join(':')
      .replace(/\b(\d)\b/g, '0$1');
  } else {
    return [
      parseInt(seconds / 60 / 60),
      parseInt((seconds / 60) % 60),
      parseInt(seconds % 60)
    ]
      .join(':')
      .replace(/\b(\d)\b/g, '0$1');
  }
}

/**
 * 获取时间的星期几
 * @method getTimeWeek
 * @param {String} 格式化前的时间.
 * @return {String} 返回计算后的星期几.
 */
const getTimeWeek = (time) => {
  let week = ['日', '一', '二', '三', '四', '五', '六'];
  let index = new Date(time).getDay();

  return week[index];
}

/**
 * 弹出类似ios提示框一样的提示
 * @method messageBox
 * @param {string} msg 提示信息
 * @param {Integer} delay 提示持续时间 default 3000
 * @param {Integer} show 显示速度 default 0
 * @param {Integer} hide 隐藏速度 default 0
 */
const messageBox = (msg, time) => {
  time = typeof time !== 'undefined' ? time : 3000;
  var cenetr = document.createElement('div');
  cenetr.innerHTML = msg;
  cenetr.className = 'center-alert';
  document.getElementsByTagName('body')[0].appendChild(cenetr);
  setTimeout(function () {
    document.getElementsByTagName('body')[0].removeChild(cenetr);
  }, time);
}

const hideToken = () => {
  if (isMobile.app()) {
    return;
  }
  const token = getQueryString('token');
  let normalUrl = window.location.href.replace(
    new RegExp('[?&]token=' + token, 'g'),
    ''
  );
  if (normalUrl.indexOf('?') === -1) {
    normalUrl = normalUrl.replace('&', '?');
  }
  if (getQueryString('token')) {
    window.history.pushState({}, 0, normalUrl);
    window.location.href = window.location.href;
  }
}

// 生成从minNum到maxNum的随机数
const randomNum = (minNum, maxNum) => {
  switch (arguments.length) {
    case 1:
      return parseInt(Math.random() * minNum + 1, 10);
    case 2:
      return parseInt(Math.random() * (maxNum - minNum + 1) + minNum, 10);
    default:
      return 0;
  }
}
const myRegExp = {
  isPhoneNumber: data => {
    let reg = /^1[0-9]{10}$/;
    if (reg.test(data)) {
      return true;
    } else {
      return false;
    }
  },
  isEmail: data => {
    let reg = /^([0-9A-Za-z\-_\.]+)@([0-9a-z]+\.[a-z]{2,3}(\.[a-z]{2})?)$/g;
    if (reg.test(data)) {
      return true;
    } else {
      return false;
    }
  },
  isWeixin: data => {
    let reg = /^[-_a-zA-Z0-9]{6,20}$/;
    if (reg.test(data)) {
      return true;
    } else {
      return false;
    }
  },
  isTaxNum: data => {
    let reg = /^[A-Z0-9]{15}$|^[A-Z0-9]{18}$|^[A-Z0-9]{20}$/;
    if (reg.test(data)) {
      return true;
    } else {
      return false;
    }
  }
}
/**
 * 小程序则设置token的key是LiteAppToken
 *
 * 其他都是token
 */
const getHeadersInToken = (token) => {
  let headers;
  if (isMiniProgram()) {
    headers = headers(token, {
      LiteAppToken: token,
      Accept: 'application/json',
      'Content-Type': 'application/json'
    });
  } else {
    headers = headers(token, {
      token,
      Accept: 'application/json',
      'Content-Type': 'application/json'
    });
  }
  return headers;
}
const JSHash = (str) => {
  let hash = 0,
    i,
    chr;
  if (str.length === 0) return hash;
  for (i = 0; i < str.length; i++) {
    chr = str.charCodeAt(i);
    hash = (hash << 5) - hash + chr;
    hash |= 0; // Convert to 32bit integer
  }
  return hash;
}
/**
 * @Desc: 以375为基准转换px
 * @Author: simbawu
 */
const pxTransform = (px) => {
  const windowWidth = window.innerWidth;
  const transformPx = (windowWidth / 375) * px;
  return transformPx;
}
/**
 * @Desc: 获取日期中文星期几
 * @Author: simbawu
 */
const getDateWeek = (date) => {
  const weeklyList = ['日', '一', '二', '三', '四', '五', '六'];
  const dateDayIndex = new Date(date).getDay();
  const week = weeklyList[dateDayIndex];
  return week;
}

/**
 * 比较两个版本的大小
 * 返回true说明版本ver1大于版本ver2
 * 返回false说明版本ver1小于版本ver2
 * 返回‘equal’说明版本ver1等于版本ver2
 */
const versionCompare = (ver1, ver2) => {
  let arr1 = ver1.split('.');
  let arr2 = ver2.split('.');
  //将两个版本号拆成数字
  let minL = Math.max(arr1.length, arr2.length);
  let pos = 0; //当前比较位
  let diff = 0; //当前为位比较是否相等

  //逐个比较如果当前位相等则继续比较下一位
  while (pos < minL) {
    diff = parseInt(arr1[pos]) - parseInt(arr2[pos]);
    if (diff != 0) {
      break;
    }
    pos++;
  }
  if (diff > 0) {
    return true;
  } else if (diff == 0) {
    return 'equal';
  } else {
    return false;
  }
}
const getBooheeAppVersion = () => {
  let version = '';
  if (isMobile.BooheeHealth()) {
    const flag = 'boohee/';
    const userAgent = navigator.userAgent;
    version = userAgent.slice(userAgent.indexOf(flag) + flag.length);
  }

  return version.replace(/iOS\//, '');
}
/**
 * @Desc: 获取多少年前的日期
 * @Author: simbawu
 */
const getHowYearsAgoDate = (years = 0, currentDate = new Date()) => {
  const howYearsAgoDate =
    currentDate.getFullYear() - years + currentDate.format('/MM/dd');
  return howYearsAgoDate;
}
/**
 * @Desc: 根据当前时间返回小时阶段时间
 * @Author: simbawu
 */
const getTimeStage = (time, stage = 1, format = 'hh:mm') => {
  if (/-/.test(time)) {
    time = time.replace(/-/g, '/');
  }
  const currentTime = new Date(time);
  const endTime = new Date(
    new Date(currentTime).valueOf() + stage * 60 * 60 * 1000
  );
  const hoursStage = `${currentTime.format(format)}-${endTime.format(
    format
  )}`;
  const timeStage = `${new Date(time).format('yyyy-MM-dd')} ${hoursStage}`;

  return timeStage;
}
/**
 * @Desc: 联系客服
 * @Author: simbawu
 */
const connectCustomeService = () => {
  if (isMobile.BooheeHealth()) {
    location.href = 'boohee://feedback_online';
  } else {
    const { token } = store.getState();
    location.href = `${pConfig.Lottery}/webapp/kefus?token=${token}`;
  }
}
/**
 * @Desc: 留言
 * @Author: simbawu
 */
const leaveMessage = (category) => {
  if (isMobile.BooheeHealth()) {
    location.href = 'boohee://feedback';
  } else {
    history.push(`/messenger?category=${category}`);
  }
}
/**
 * @Desc: 各渠道购买
 * @Author: simbawu
 */
const gotoChannelsPurchase = ({ appUrl, taobaoUrl, weixinUrl }) => {
  if (isMobile.WeixinMiniProgram()) {
    // 微信小程序
    wx.miniProgram.navigateTo({
      url: weixinUrl
    });
  } else if (isMobile.AliApp()) {
    // 淘宝
    if (taobaoUrl) location.href = taobaoUrl;
  } else if (isMobile.Food()) {
    // 食物库app 打开小程序
    location.href = `foodlibrary://mini_program/gh_353de0484054${weixinUrl}`;
  } else {
    // 薄荷健康app
    location.href = appUrl;
  }
}
/**
 * @Desc: 十六进制色转rgb
 * @Author: simbawu
 */
const hexToRgb = (hex) => {
  return hex
    .replace(
      /^#?([a-f\d])([a-f\d])([a-f\d])$/i,
      (m, r, g, b) => '#' + r + r + g + g + b + b
    )
    .substring(1)
    .match(/.{2}/g)
    .map(x => parseInt(x, 16));
}
/**
 * @Desc: 空值判断
 * @Author: simbawu
 */
const isEmpty = (obj) => {
  // 检验null和undefined
  if (!obj && obj !== 0 && obj !== '') {
    return true;
  }
  // 检验数组
  if (Array.prototype.isPrototypeOf(obj) && obj.length === 0) {
    return true;
  }
  // 检验对象
  if (Object.prototype.isPrototypeOf(obj) && Object.keys(obj).length === 0) {
    return true;
  }
  return false;
}
const getCountDown = (funtureDate, showDay = true) => {
  let presentDate = new Date();
  let funtureTime = new Date(funtureDate.replace(/-/g, "/")).getTime();
  let presenTime = new Date(presentDate).getTime();
  let allTime = funtureTime - presenTime;
  let allSecond = parseInt(allTime / 1000);
  let day = parseInt(allSecond / 3600 / 24);
  let hour = parseInt((allSecond / 3600) % 24);
  let minute = parseInt((allSecond / 60) % 60);
  let second = parseInt(allSecond % 60);
  hour = hour > 0 ? hour : 0;
  minute = minute > 0 ? minute : 0;
  second = second > 0 ? second : 0;
  let countdown = {
    hour,
    minute,
    second
  };
  if (showDay) {
    countdown.day = day > 0 ? day : 0;
  } else {
    countdown.hour = hour + day * 24;
  }
  return countdown;
}
/**
  * 拼接图片的 url
  */
const setImgUrl = (path, imgName) => {
  return `https://up.boohee.cn/house/u/pixiu/${path}/${imgName}@2x.png`;
};
/*
 * 调用协议
 */

const useProtocol = (protocalList = []) => {
  console.log("调用使用协议函数");
  console.log("判断是否为薄荷健康app：", !isMobile.BooheeHealth())
  if (!isMobile.BooheeHealth()) return;
  // 字符串直接调用
  if (typeof protocalList === 'string') {
    console.log('最后调用协议', protocalList)
    location.href = protocalList;
    return;
  } else if (Array.isArray(protocalList)) {
    // 数组顺序调用
    protocalList.forEach((item, index) => {
      setTimeout(() => {
        location.href = item;
      }, index * 100);
    });
  }
};
/**
 * @param {String} version 当前版本
 * @param {String} targetVersion 目标版本
 * @param {number} exponent 每个子版本号位数
 * @Desc: 比较版本号大小。0：相等，1：version大于targetVersion，-1：version小于targetVersion
 */
const newVersionCompare = (version, targetVersion, exponent) => {
  function versionToNumber(version, length, exponent) {
    if (arguments.length < 3) {
      return 0;
    }
    const arr = version.split('.');
    version = 0;
    arr.forEach(function (value) {
      version += value * Math.pow(10, length * exponent - 1);
      length--;
    });
    return version;
  }

  exponent = exponent || 2;
  if (!version || !targetVersion) {
    throw new Error('Need two versions to compare!');
  }
  if (version === targetVersion) {
    return 0;
  }
  const length = Math.max(
    version.split('.').length,
    targetVersion.split('.').length
  );
  const getVersionNumber = (function (length, exponent) {
    return function (version) {
      return versionToNumber(version, length, exponent);
    };
  })(length, exponent);
  version = getVersionNumber(version);
  targetVersion = getVersionNumber(targetVersion);
  return version > targetVersion ? 1 : version < targetVersion ? -1 : 0;
};
/**
 * 当前版本是否高于某版本
 * aVersion Android 版本
 * iVersion iOS 版本
 */
const isVersionEqualOrSuper = (aVersion, iVersion) => {
  const version = getBooheeAppVersion();
  const isShow =
    (isMobile.BooheeHealthAndroid() &&
      newVersionCompare(version, aVersion) !== -1) ||
    (isMobile.BooheeHealthIOS() && newVersionCompare(version, iVersion) !== -1) ||
    !isMobile.BooheeHealth();
  return isShow;
};

const getAppKey = () => {
  const key = isMobile.WeixinMiniProgram() ? 'whale_lite' : 'one';
  return getQueryString('app_key') || key
}

export default {
  toQueryString,
  serializeQueryString,
  getQueryString,
  isMobile,
  guid,
  isMiniProgram,
  headers,
  saveById,
  downloadFile,
  getDateDiff,
  formatTime,
  getCountDown,
  isEmpty,
  hexToRgb,
  gotoChannelsPurchase,
  leaveMessage,
  connectCustomeService,
  getTimeStage,
  getHowYearsAgoDate,
  getBooheeAppVersion,
  versionCompare,
  getDateWeek,
  pxTransform,
  JSHash,
  getHeadersInToken,
  myRegExp,
  randomNum,
  hideToken,
  messageBox,
  getTimeWeek,
  showToast,
  setImgUrl,
  useProtocol,
  isVersionEqualOrSuper,
  getAppKey
}
